module.exports = __webpack_public_path__ + "files/f406a1bf29c1f4d1ba322cf0d695fe5c.png";